// Contracts V1
export { getContract as getContractMexicoV1 } from './V1/mexico'
export { getContract as getContractCanadaV1 } from './V1/canada'

// Contracts V2
export { getContract as getContractMexicoV2 } from './V2/mexico'
export { getContract as getContractCanadaV2 } from './V2/canada'

// Contracts V3
export { getContract as getContractMexicoV3 } from './V3/mexico'
export { getContract as getContractCanadaV3 } from './V3/canada'
export { getContract as getContractEuropaV3 } from './V3/europe'

// Contracts V4
export { getContract as getContractMexicoV4 } from './V4/mexico'
export { getContract as getContractCanadaV4 } from './V4/canada'
export { getContract as getContractEuropaV4 } from './V4/europe'
export { getContract as getContractUSAV4 } from './V4/usa'

// Contracts V4
export { getContract as getContractMexicoV5 } from './V5/mexico'
export { getContract as getContractCanadaV5 } from './V5/canada'
export { getContract as getContractEuropaV5 } from './V5/europe'
export { getContract as getContractUSAV5 } from './V5/usa'